export const sumLessonItemCounts = (summary = []) =>
  summary.reduce((counts, item) => {
    const lessonId = String(item?.lessonId || "");
    if (!lessonId) return counts;

    counts[lessonId] = (counts[lessonId] || 0) + Number(item?.count || 0);
    return counts;
  }, {});
